import { useEffect, useState } from "react";

/** Returns a delayed copy of `value` that only updates after `delay` ms
 *  of stillness. Use to throttle search inputs into the BE — typing
 *  fires re-renders cheaply, but the network call only happens once
 *  the user pauses. */
export const useDebouncedValue = <T>(value: T, delay = 300): T => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);
    return debounced;
};
